import { Box, FormControl, Typography } from "@mui/material";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { loginSchema } from "../../form-schema";
import { logIn } from "../../stores/auth";
import { LoginPayload } from "../../stores/auth/Interface";
import { useAppDispatch } from "../../stores/store";
import theme from "../../theme";
import CustomButton from "../common-components/CustomButton";
import InputField from "../common-components/InputField";
import { useState } from "react";
import { EmailIcon, PasswordIcon } from "../../assets/Icon/singUpIcon";
import { setToast } from "../../stores/toast/toastslice";

const LoginForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // regex to detect email inside text
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailMessage, setEmailMessage] = useState("");

  const handleLogin = async (values: LoginPayload) => {
    localStorage.clear();
    setLoading(true);
    try {
      const response = await dispatch<any>(logIn(values));

      if (response?.payload?.status === 1) {
        setLoading(false);
        localStorage.setItem("user_token", response.payload?.data.access_token);
        localStorage.setItem(
          "firstName",
          response.payload?.data?.user_data?.first_name,
        );
        localStorage.setItem(
          "lastName",
          response.payload?.data?.user_data?.last_name,
        );
        localStorage.setItem("userId", response.payload?.data?.user_data?.id);
        localStorage.setItem(
          "roleId",
          response.payload?.data?.user_data?.role_id,
        );
        dispatch<any>(
          setToast({
            message: response?.payload?.message,
            type: "success",
            title: "Success",
          }),
        ); // ✅ Global toast

        setTimeout(() => {
          const roleId = Number(localStorage.getItem("roleId"));

          if (roleId === 1) {
            navigate("/admin-dashboard");
          } else {
            navigate("/dashboard");
          }
        }, 200);
      } else {
        const message = response?.payload;
        // Debugging log
        setLoading(false);
        if (message?.match(emailRegex)?.[0]) {
          setEmail(message?.match(emailRegex)?.[0]);
          setEmailMessage(message);
          return;
        }
        dispatch<any>(
          setToast({
            message: message,
            type: "error",
            title: "Error",
          }),
        );
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: handleLogin,
  });

  return (
    <>
      <div className="form-container">
        {/* <div>
          <Typography
            variant="h1"
            className="logo-title"
            style={{ color: "#05000B", marginBottom: "20px" }}
          >
            Log in to your account
          </Typography>
          <Typography
            variant="h3"
            className="logo-title1"
            style={{ color: "#6C6F71" }}
          >
            Enter your credentials to securely access your account and unlock
            all features tailored to you.
          </Typography>
        </div> */}
        {email?.length > 0 && (
          <Box
            sx={{
              textAlign: "start",
              width: 500,
              lineHeight: "24px",
            }}
          >
            <a
              href={`mailto:${email}`}
              style={{
                color: "red",
                fontSize: "16px",
                textAlign: "start",
                textDecoration: "none",
                cursor: "pointer",
                fontWeight: 400,
              }}
            >
              {emailMessage?.replace(`${email}.`, "")}
              <span
                style={{
                  color: "red",
                  textDecoration: "underline",
                }}
              >
                {email}
              </span>
            </a>
          </Box>
        )}
        <form onSubmit={formik.handleSubmit}>
          <FormControl
            variant="standard"
            sx={{ width: "100%", paddingTop: "10px" }}
          >
            <>
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                Email Address
              </Typography>
              <InputField
                formik={formik}
                margin="normal"
                placeholder={"Enter email address"}
                type="text"
                icon={<EmailIcon />}
                name="email"
                minWidth="389px"
              />
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                Password
              </Typography>
              <InputField
                formik={formik}
                margin="normal"
                placeholder={"Enter password"}
                type="password"
                name="password"
                icon={<PasswordIcon />}
                minWidth="353px"
              />
            </>
            <Typography
              variant="h4"
              style={{
                color: theme.palette.myCustomColor.link,
                marginTop: "10px",
                marginBottom: "30px",
              }}
            >
              <Link
                to="/forget-password"
                style={{
                  textDecoration: "none",
                  color: theme.palette.myCustomColor.link,
                }}
              >
                Forgot Password ?
              </Link>
            </Typography>
            <CustomButton
              btnTitle={"Log In"}
              maxwidth="450px"
              type="submit"
              loading={loading}
            />
          </FormControl>
        </form>
      </div>
    </>
  );
};

export default LoginForm;
